import ActionTypes from "../constants/action_types";
import basePath from "base_path";
import createReduxPromiseAction from "utils/create_redux_promise_action";
import {OrganisationId} from "common/types/organisation";
import {ProjectId} from "common/types/project";
import {IssueId} from "common/types/issue";

export default function removeAppliedAmendments(requestor) {
  return createReduxPromiseAction(
    ActionTypes.DOCUMENT_ISSUE_REMOVE_APPLIED_AMENDMENTS,
    (
      organisationId: OrganisationId,
      projectId: ProjectId,
      documentIssueId: IssueId,
      amendmentIds: string[],
    ) => {
      return requestor
        .patch(
          `${basePath}/organisation/${organisationId}/project/${projectId}/document_issue/${documentIssueId}/amendment/remove`,
          {amendment_ids: amendmentIds},
          {withCredentials: true},
        )
        .then(response => response.data);
    },
  );
}
